import { useQueryClient } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import { patchHighlights } from "./patchHighlights";

// «Сделать клип» и «Сделать все» (`POST /api/highlights/clips`). Повтор безопасен:
// заказанный момент сервер второй раз не заказывает, поэтому без ключа идемпотентности.
export const useRequestClips = () => {
  const queryClient = useQueryClient();
  const mutation = $api.useMutation("post", "/api/highlights/clips", {
    onSuccess: (response) => {
      patchHighlights(queryClient, response.items);
    },
  });
  const request = (highlightIds: number[]) => {
    mutation.mutate({ body: { highlight_ids: highlightIds } });
  };
  // Моменты, заказ которых сейчас идёт: их кнопки — со спиннером.
  const pendingIds: number[] = mutation.isPending ? mutation.variables.body.highlight_ids : [];
  return { ...mutation, request, pendingIds };
};
